import axios from "axios";
import { API_URL } from "../constants";
import { AssetRequest, AssetRequestStatus } from "types/AssetRequest";

/**
 * «Turto prašymai» — erp-backend api/controllers/asset-requests. The queue
 * needs the assets module; /mine and the create call are open to any
 * active member (an ordinary employee may only create for themselves).
 */

export async function fetchAssetRequests(
  companyId: string,
  status: AssetRequestStatus
): Promise<AssetRequest[]> {
  const res = await axios.get(`${API_URL}/${companyId}/asset-requests`, { params: { status } });
  return res.data.requests;
}

/** The caller's own requests, newest first. */
export async function fetchMyAssetRequests(companyId: string): Promise<AssetRequest[]> {
  const res = await axios.get(`${API_URL}/${companyId}/asset-requests/mine`);
  return res.data.requests;
}

export async function createAssetRequest(
  companyId: string,
  body: { employeeId: string; comment: string }
): Promise<AssetRequest> {
  const res = await axios.post(`${API_URL}/${companyId}/asset-requests`, body);
  return res.data.request;
}

export async function completeAssetRequest(
  companyId: string,
  requestId: string,
  note?: string
): Promise<AssetRequest> {
  // The note is optional: an empty box sends no `note` key at all.
  const res = await axios.post(`${API_URL}/${companyId}/asset-requests/${requestId}/complete`, {
    note: note || undefined,
  });
  return res.data.request;
}

export async function rejectAssetRequest(
  companyId: string,
  requestId: string,
  reason: string
): Promise<AssetRequest> {
  const res = await axios.post(`${API_URL}/${companyId}/asset-requests/${requestId}/reject`, { reason });
  return res.data.request;
}
